import * as u from "react";
import E from "react";
import { outlinedInputClasses as x, iconButtonClasses as U, OutlinedInput as V, InputAdornment as D, IconButton as J, FormControl as G } from "@mui/material";
import { s as b, a as K } from "./styled-38387a7e.js";
import { g as y, c as k, _ as f, a as O, p as r } from "./createTheme-02ce03eb.js";
import { j as g, c as z, r as j } from "./useTheme-efe1290c.js";
import { f as $ } from "./formControlState-9148c46f.js";
import { u as h } from "./useFormControl-c75d3f58.js";
import { g as T, u as L, c as F } from "./useThemeProps-ee4acb93.js";
import { r as N, i as w } from "./createSvgIcon-b5d2ebc3.js";
function Q(e) {
  return y("MuiFormHelperText", e);
}
const X = T("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]), R = X;
var I;
const Y = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], Z = (e) => {
  const {
    classes: o,
    contained: t,
    size: a,
    disabled: i,
    error: c,
    filled: l,
    focused: d,
    required: n
  } = e, s = {
    root: ["root", i && "disabled", c && "error", a && `size${k(a)}`, t && "contained", d && "focused", l && "filled", n && "required"]
  };
  return F(s, Q, o);
}, ee = b("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, o) => {
    const {
      ownerState: t
    } = e;
    return [o.root, t.size && o[`size${k(t.size)}`], t.contained && o.contained, t.filled && o.filled];
  }
})(({
  theme: e,
  ownerState: o
}) => f({
  color: (e.vars || e).palette.text.secondary
}, e.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${R.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${R.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}, o.size === "small" && {
  marginTop: 4
}, o.contained && {
  marginLeft: 14,
  marginRight: 14
})), S = /* @__PURE__ */ u.forwardRef(function(o, t) {
  const a = L({
    props: o,
    name: "MuiFormHelperText"
  }), {
    children: i,
    className: c,
    component: l = "p"
  } = a, d = O(a, Y), n = h(), s = $({
    props: a,
    muiFormControl: n,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), p = f({}, a, {
    component: l,
    contained: s.variant === "filled" || s.variant === "outlined",
    variant: s.variant,
    size: s.size,
    disabled: s.disabled,
    error: s.error,
    filled: s.filled,
    focused: s.focused,
    required: s.required
  }), m = Z(p);
  return /* @__PURE__ */ g.jsx(ee, f({
    as: l,
    ownerState: p,
    className: z(m.root, c),
    ref: t
  }, d, {
    children: i === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      I || (I = /* @__PURE__ */ g.jsx("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : i
  }));
});
process.env.NODE_ENV !== "production" && (S.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: r.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: r.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: r.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: r.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: r.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   */
  variant: r.oneOfType([r.oneOf(["filled", "outlined", "standard"]), r.string])
});
const re = S, oe = b(te)(({ theme: e }) => ({
  color: e.palette.darkBlue.c70,
  marginLeft: "0px",
  "&.Mui-error": {
    color: e.palette.negative.c100
  }
}));
function te(e) {
  return /* @__PURE__ */ E.createElement(re, { ...e });
}
var q = {}, se = w;
Object.defineProperty(q, "__esModule", {
  value: !0
});
var H = q.default = void 0, ae = se(N()), ne = j(), le = (0, ae.default)(/* @__PURE__ */ (0, ne.jsx)("path", {
  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5 2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4 1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"
}), "VisibilityOffOutlined");
H = q.default = le;
var M = {}, ie = w;
Object.defineProperty(M, "__esModule", {
  value: !0
});
var B = M.default = void 0, ce = ie(N()), de = j(), ue = (0, ce.default)(/* @__PURE__ */ (0, de.jsx)("path", {
  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
}), "VisibilityOutlined");
B = M.default = ue;
const pe = b(u.forwardRef(fe))(({ theme: e, noBorder: o, error: t }) => ({
  marginTop: e.spacing(1),
  backgroundColor: e.palette.common.white,
  "&:hover": {
    [`.${x.notchedOutline}`]: {
      borderColor: t ? e.palette.negative.c100 : e.palette.darkBlue.c30
    }
  },
  [`&.${x.focused}`]: {
    [`.${x.notchedOutline}`]: {
      borderWidth: "1px",
      borderColor: t ? e.palette.negative.c120 : e.palette.blue.c100
    }
  },
  [`&.${x.error}`]: {
    backgroundColor: e.palette.negative.c5,
    [`.${x.notchedOutline}`]: {
      borderWidth: "1px",
      borderColor: e.palette.negative.c120
    }
  },
  [`.${x.notchedOutline}`]: {
    borderWidth: o ? 0 : "1px",
    borderColor: e.palette.darkBlue.c20
  },
  [`.${x.input}`]: {
    ...e.typography.body1,
    color: e.palette.darkBlue.c100,
    borderRadius: 4,
    padding: "13px 15px",
    height: 25,
    "::placeholder": {
      color: e.palette.darkBlue.c50
    },
    "&.Mui-disabled": {
      WebkitTextFillColor: e.palette.darkBlue.c50
    }
  },
  [`.${U.root}`]: {
    color: e.palette.darkBlue.c30
  }
}));
function fe({ type: e = "text", error: o, fullWidth: t, required: a, ...i }, c) {
  const [l, d] = u.useState(!1);
  let n = null;
  function s() {
    d((p) => !p);
  }
  return e === "password" && (n = /* @__PURE__ */ u.createElement(D, { position: "end" }, /* @__PURE__ */ u.createElement(J, { onClick: s, edge: "end" }, l ? /* @__PURE__ */ u.createElement(H, null) : /* @__PURE__ */ u.createElement(B, null)))), /* @__PURE__ */ u.createElement(
    V,
    {
      type: l ? "text" : e,
      endAdornment: n,
      error: o,
      fullWidth: t,
      required: a,
      ref: c,
      ...i
    }
  );
}
function me(e) {
  return y("MuiFormLabel", e);
}
const be = T("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), v = be, xe = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], ve = (e) => {
  const {
    classes: o,
    color: t,
    focused: a,
    disabled: i,
    error: c,
    filled: l,
    required: d
  } = e, n = {
    root: ["root", `color${k(t)}`, i && "disabled", c && "error", l && "filled", a && "focused", d && "required"],
    asterisk: ["asterisk", c && "error"]
  };
  return F(n, me, o);
}, ge = b("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, o) => f({}, o.root, e.color === "secondary" && o.colorSecondary, e.filled && o.filled)
})(({
  theme: e,
  ownerState: o
}) => f({
  color: (e.vars || e).palette.text.secondary
}, e.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${v.focused}`]: {
    color: (e.vars || e).palette[o.color].main
  },
  [`&.${v.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${v.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), Ce = b("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, o) => o.asterisk
})(({
  theme: e
}) => ({
  [`&.${v.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), A = /* @__PURE__ */ u.forwardRef(function(o, t) {
  const a = L({
    props: o,
    name: "MuiFormLabel"
  }), {
    children: i,
    className: c,
    component: l = "label"
  } = a, d = O(a, xe), n = h(), s = $({
    props: a,
    muiFormControl: n,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), p = f({}, a, {
    color: s.color || "primary",
    component: l,
    disabled: s.disabled,
    error: s.error,
    filled: s.filled,
    focused: s.focused,
    required: s.required
  }), m = ve(p);
  return /* @__PURE__ */ g.jsxs(ge, f({
    as: l,
    ownerState: p,
    className: z(m.root, c),
    ref: t
  }, d, {
    children: [i, s.required && /* @__PURE__ */ g.jsxs(Ce, {
      ownerState: p,
      "aria-hidden": !0,
      className: m.asterisk,
      children: [" ", "*"]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (A.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   */
  color: r.oneOfType([r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: r.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: r.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: r.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: r.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const ye = A;
function ke(e) {
  return y("MuiInputLabel", e);
}
const Oe = T("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]), _ = Oe, ze = ["disableAnimation", "margin", "shrink", "variant", "className"], $e = (e) => {
  const {
    classes: o,
    formControl: t,
    size: a,
    shrink: i,
    disableAnimation: c,
    variant: l,
    required: d
  } = e, s = F({
    root: ["root", t && "formControl", !c && "animated", i && "shrink", a === "small" && "sizeSmall", l],
    asterisk: [d && "asterisk"]
  }, ke, o);
  return f({}, o, s);
}, he = b(ye, {
  shouldForwardProp: (e) => K(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, o) => {
    const {
      ownerState: t
    } = e;
    return [{
      [`& .${v.asterisk}`]: o.asterisk
    }, o.root, t.formControl && o.formControl, t.size === "small" && o.sizeSmall, t.shrink && o.shrink, !t.disableAnimation && o.animated, o[t.variant]];
  }
})(({
  theme: e,
  ownerState: o
}) => f({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, o.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, o.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, o.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !o.disableAnimation && {
  transition: e.transitions.create(["color", "transform", "max-width"], {
    duration: e.transitions.duration.shorter,
    easing: e.transitions.easing.easeOut
  })
}, o.variant === "filled" && f({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, o.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, o.shrink && f({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, o.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), o.variant === "outlined" && f({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, o.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, o.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), P = /* @__PURE__ */ u.forwardRef(function(o, t) {
  const a = L({
    name: "MuiInputLabel",
    props: o
  }), {
    disableAnimation: i = !1,
    shrink: c,
    className: l
  } = a, d = O(a, ze), n = h();
  let s = c;
  typeof s > "u" && n && (s = n.filled || n.focused || n.adornedStart);
  const p = $({
    props: a,
    muiFormControl: n,
    states: ["size", "variant", "required"]
  }), m = f({}, a, {
    disableAnimation: i,
    formControl: n,
    shrink: s,
    size: p.size,
    variant: p.variant,
    required: p.required
  }), C = $e(m);
  return /* @__PURE__ */ g.jsx(he, f({
    "data-shrink": s,
    ownerState: m,
    ref: t,
    className: z(C.root, l)
  }, d, {
    classes: C
  }));
});
process.env.NODE_ENV !== "production" && (P.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   */
  color: r.oneOfType([r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), r.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: r.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: r.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: r.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: r.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: r.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: r.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: r.oneOfType([r.oneOf(["normal", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
const Te = P, Le = b(Fe)(({ theme: e }) => ({
  ...e.typography.body2M,
  color: e.palette.darkBlue.c100,
  transform: "none",
  position: "relative",
  [`.${_.asterisk}`]: {
    color: e.palette.negative.c100
  },
  [`&.${_.focused}`]: {
    color: e.palette.darkBlue.c100
  }
}));
function Fe(e) {
  return /* @__PURE__ */ E.createElement(Te, { shrink: !0, ...e });
}
const qe = {
  shouldForwardProp: (e) => !e.startsWith("$")
}, Be = b(u.forwardRef(Me), qe)(() => ({}));
function Me({
  label: e,
  helperText: o,
  error: t,
  fullWidth: a,
  required: i,
  noBorder: c = !1,
  type: l,
  name: d,
  InputLabelProps: n,
  className: s,
  sx: p,
  InputProps: m,
  ...C
}, W) {
  return /* @__PURE__ */ u.createElement(G, { fullWidth: a, className: s, sx: p, ref: W }, e && /* @__PURE__ */ u.createElement(Le, { required: i, ...n }, e), /* @__PURE__ */ u.createElement(
    pe,
    {
      type: l,
      name: d,
      error: t,
      fullWidth: a,
      required: i,
      noBorder: c,
      ...m,
      ...C
    }
  ), /* @__PURE__ */ u.createElement(oe, { error: t }, o));
}
export {
  Le as M,
  pe as a,
  oe as b,
  Be as c
};
